import React, { useState } from "react";
import {
  Table,
  Pagination,
  Spin,
  Button,
  Input,
  Form,
  Modal,
  Typography,
  message,
  Popover,
  Card,
  Descriptions,
  Tag,
  Select,
  Flex,
} from "antd";
import moment from "moment";
import { PlusCircleFilled, EditOutlined } from "@ant-design/icons";
import clientService from "../../services/clientService";
import { useMediaQuery } from "react-responsive";
import usePermissions from "../../hooks/usePermissions";
import axiosInstance from "../../services/axiosInstance";
import { catchError } from "../../utils/errorHandler";
import RemarksAgentList from "./RemarksAgentList";
function MobileViewAgentList({ agents, showModal, pagination, setPagination }) {
  const { hasPermission } = usePermissions();
  return (
    <div>
      {agents.map((agent) => (
        <Card
          key={agent.refer_id}
          style={{ marginBottom: "1rem" }}
          actions={[
            hasPermission("can_update_become_agent_remarks") && (
              <Button
                type="link"
                icon={<PlusCircleFilled />}
                onClick={() => showModal(agent)}>
                Add Remarks
              </Button>
            ),
          ]}>
          <Descriptions bordered>
            <Descriptions.Item label="Client Name">
              {agent.full_name}
            </Descriptions.Item>
            <Descriptions.Item label="Client Username">
              {agent.username}
            </Descriptions.Item>
            <Descriptions.Item label="Contact No.">
              {agent.contact_no}
            </Descriptions.Item>
            <Descriptions.Item label="Email">{agent?.email}</Descriptions.Item>
            {/* <Descriptions.Item label="Referred By">
              {agent.referred_by}
            </Descriptions.Item> */}
            
            {/* <Descriptions.Item label="Status">{agent.status}</Descriptions.Item> */}
            <Descriptions.Item label="Remark Logs">
              <RemarksAgentList record={agent} />
            </Descriptions.Item>

            <Descriptions.Item label="Requested At">
              {moment(agent.become_agent_requested_at)
                .local()
                .format("DD-MM-YYYY hh:mm A")}
            </Descriptions.Item>
            <Descriptions.Item label="Status">
              <Tag>
                {agent.status}
              </Tag>
            </Descriptions.Item>
          </Descriptions>
        </Card>
      ))}
      <Pagination
        current={pagination.current}
        pageSize={pagination.pageSize}
        total={pagination.total}
        onChange={(page, pageSize) =>
          setPagination({ ...pagination, current: page, pageSize })
        }
        style={{ textAlign: "center", marginTop: 16 }}
      />
    </div>
  );
}
function AgentsList({ agents, loading, pagination, setPagination, getAgents, remarksStatus }) {
  const { hasPermission } = usePermissions();
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [remarks, setRemarks] = useState(""); // Track remarks per record
  const [isModalVisible, setIsModalVisible] = useState(false); // State to control modal visibility
  const [currentRecord, setCurrentRecord] = useState(null); // Track the current record for modal
  const [formSubmitLoading, setFormSubmitLoading] = useState(false);
  const { Title } = Typography;



  const showModal = (record) => {
    setCurrentRecord(record);
    setRemarks(record.status || ""); // Pre-fill with existing remarks if available
    setIsModalVisible(true);
  };

  const columns = React.useMemo(() => {
    if (agents && agents.length > 0) {
      // Initialize columns based on the agent's keys
      const baseColumns = [
        ...Object.keys(agents[0])
          .filter((key) => key !== "uid" && key !== "become_agent_requested_at" && key !== "status")
          .map((key) => {
            if (key === "full_name") {
              return {
                title: "Full Name",
                dataIndex: "client_name",
                key: "client_name",
                render: (text, record) => (
                  <>
                    {record.full_name}
                    <br />
                    <small style={{ color: "gray" }}>
                      {moment(record.become_agent_requested_at)
                        .local()
                        .format("DD-MM-YYYY hh-mm a")}
                    </small>
                  </>
                ),
              };
            }

            if (key === "client_username") {
              return {
                title: "Client Username",
                dataIndex: "client_username",
                key: "client_username",
                render: (text, record) => (
                  <>
                    {text}
                    <br />
                    <small style={{ color: "gray" }}>{record.contact_no}</small>
                  </>
                ),
              };
            }

            if (key === "referred_by") {
              return {
                title: "Referred By",
                dataIndex: "referred_by",
                key: "referred_by",
              };
            }

            if (key === "remarks") {
              return {
                title: "Remarks Logs",
                key: "remarks_logs",
                render: (_, record) => <RemarksAgentList record={record} />,
              };
              //   title: "Remarks",
              //   dataIndex: key,
              //   key,
              //   render: (text) => (
              //     <Popover
              //       content={
              //         <div
              //           style={{ wordBreak: "break-word", maxWidth: "190px" }}>
              //           {text || "No remarks available"}
              //         </div>
              //       }
              //       title="Remarks"
              //       trigger="hover"
              //       placement="topLeft">
              //       <Button type="link" style={{ padding: 0 }}>
              //         View
              //       </Button>
              //     </Popover>
              //   ),
              // };
            }

            return {
              title: key.replace("_", " ").toUpperCase(),
              dataIndex: key,
              key,
            };
          }),
      ];

      // Conditionally add the Edit Remark column if permission is granted
      if (hasPermission("can_update_become_agent_remarks")) {
        baseColumns.push({
          title: "Add Remark",
          key: "edit_remark",
          render: (_, record) => (
            <Button
              type="link"
              icon={<PlusCircleFilled />}
              onClick={() => showModal(record)}
            />
          ),
        });
      }
      baseColumns.push({
        title: "Status",
        dataIndex: "status",
        key: "status",
        render: (text) => (
          <Tag>
            {text}
          </Tag>
        ),
      });


      return baseColumns;
    }
    return [];
  }, [agents, hasPermission]);

  return (
    <div>
      {loading ? (
        <Spin size="large" />
      ) : isMobile ? (
        <MobileViewAgentList
          agents={agents}
          showModal={showModal}
          pagination={pagination}
          setPagination={setPagination}
        />
      ) : (
        <Table
          dataSource={agents}
          columns={columns}
          rowKey="refer_id"
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
            onChange: (page, pageSize) =>
              setPagination({ ...pagination, current: page, pageSize }),
          }}
        />
      )}
      {/* Modal for editing remarks */}
      <Modal
        className="custom-modal2"
        title={
          <div
            className="custom-modal-header"
            style={{ display: "flex", justifyContent: "space-between" }}>
            <Title
              level={3}
              style={{
                color: "white",
                margin: 0,
                position: "relative",
                marginLeft: "10px",
              }}>
              Add Remarks
            </Title>
          </div>
        }
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        destroyOnClose>
        <Form
          initialValues={{
            status: remarks,
          }}
          onFinish={async (values) => {
            setFormSubmitLoading(true);
            const payload = {
              remarks: values.remarks,
              status: values.status
            }
            try {
              const response = await axiosInstance.post(
                `/client/v2/become-an-agent-log/create/${currentRecord?.uid}/`,
                payload
              );

              if (response.status === 201) {
                message.success(response.data.data);
                getAgents();
                setIsModalVisible(false);
                setFormSubmitLoading(false);
              }
            } catch (error) {
              setFormSubmitLoading(false);
              await catchError(error);
            }
          }}>
          <Form.Item name="status">
            <Select
              style={{ width: '100%' }}
              placeholder="Select Status"
            >
              {remarksStatus?.map((item) => (
                <Select.Option value={item.key}>{item.label}</Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="remarks"
            rules={[{ required: true, message: "Please write remarks" }]}>
            <Input.TextArea placeholder="Write remarks" />
          </Form.Item>
          <Flex align="flex-end" justify="flex-end" style={{ width: "100%" }}>
            <Button type="primary" htmlType="submit">
              {formSubmitLoading ? <Spin /> : "Submit"}
            </Button>
          </Flex>
        </Form>
      </Modal>
    </div>
  );
}

export default AgentsList;
